import React, { useCallback, useEffect, useState, memo, useContext,useRef } from 'react';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import axios from 'axios';
import { fetchTKModel } from "../../api/requests";
import { TKModelContext } from '../../context/TKModelContext';
import { Form, Row, Col, Button, Card } from 'react-bootstrap';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import './OperationForm.css';
import { notifyError } from '../../../../utils/toasts';

const OperationForm = ({divisionId, enterpriseId}) => {
  console.log(enterpriseId)
  const { updateServerData,
    productSheetId,
    selectedOperationData,
    finalNomenclature,
    serverData,
    selectedNomenclatureId,
    selectedNomenclatureOperation
  } = useContext(TKModelContext);

  const finalNomenclatureId = serverData?.final_nomenclature_id;
  // схема валидации Yup
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required('Название операции обязательно')
      .min(2, 'Название операции должно содержать минимум 2 символа')
      .max(100, 'Название операции не должно превышать 100 символов'),
    description: Yup.string()
      /*  .required('Описание операции обязательно')
       .min(1, 'Описание операции должно содержать минимум 1 символ') */
      .max(1000, 'Описание не должно превышать 1000 символов'),
    incoming_nomenclature: Yup.array().of(
      Yup.object().shape({
        nomenclature_id: Yup.string()
          .required('Выберите номенклатуру'),
        quantity: Yup.number()
          .typeError('Количество должно быть числом')
          .required('Количество обязательно')
          .min(1, 'Количество должно быть не менее 1'),
      })
    ),
    outgoing_nomenclature: Yup.array().of(
      Yup.object().shape({
        nomenclature_id: Yup.string()
          .required('Выберите номенклатуру'),
        quantity: Yup.number()
          .typeError('Количество должно быть числом')
          .required('Количество обязательно')
          .min(1, 'Количество должно быть не менее 1'),
      })
    ),
    equipment_settings: Yup.array().of(
      Yup.object().shape({
        equipment_group_id: Yup.string()
          .required('Выберите группу оборудования'),
        // Удаляем execution_time и добавляем новые поля
        hours: Yup.number()
          .typeError('Часы должны быть числом')
          .min(0, 'Часы не могут быть отрицательными')
          .default(0),
        minutes: Yup.number()
          .typeError('Минуты должны быть числом')
          .min(0, 'Минуты не могут быть отрицательными')
          .max(59, 'Минуты должны быть меньше 60')
          .default(0),
        seconds: Yup.number()
          .typeError('Секунды должны быть числом')
          .min(0, 'Секунды не могут быть отрицательными')
          .max(59, 'Секунды должны быть меньше 60')
          .default(0),
        is_parallel_process: Yup.boolean(),
        min_parallel_operations: Yup.number()
          .typeError('Минимальное количество должно быть числом')
          .when('is_parallel_process', {
            is: true,
            then: (schema) => schema
              .required('Минимальное количество обязательно при параллельном выполнении')
              .min(1, 'Минимальное количество должно быть не менее 1'),
            otherwise: (schema) => schema
              .notRequired()
              .nullable(),
          }),
        max_parallel_operations: Yup.number()
          .typeError('Максимальное количество должно быть числом')
          .when(['is_parallel_process', 'min_parallel_operations'], {
            is: (is_parallel_process) => is_parallel_process === true,
            then: (schema) => schema
              .required('Максимальное количество обязательно при параллельном выполнении')
              .min(
                Yup.ref('min_parallel_operations'),
                'Максимальное количество должно быть больше или равно минимальному'
              ),
            otherwise: (schema) => schema
              .notRequired()
              .nullable(),
          }),
      })
    ),
  });

  const { control, handleSubmit, setValue, watch, formState: { errors }, reset } = useForm({
    resolver: yupResolver(validationSchema),
    mode: 'onChange'
  });
  const resetFormToInitialState = useCallback(() => {
    reset({
      name: '',
      description: '',
      incoming_nomenclature: [],
      outgoing_nomenclature: finalNomenclatureId ? [{ nomenclature_id: finalNomenclatureId, quantity: 1 }] : [],
      equipment_settings: []
    });
    setOperationId('');
  }, [reset, finalNomenclatureId]);
  

  const [nomenclatureOptions, setNomenclatureOptions] = useState([]);
  const [equipmentGroups, setEquipmentGroups] = useState([]);
  const [operationId, setOperationId] = useState("");

  const { fields: incomingNomenclatureFields, append: appendIncomingNomenclature, replace: replaceIncomingNomenclature, remove: removeIncomingNomenclature } = useFieldArray({
    control,
    name: "incoming_nomenclature"
  });

  const { fields: outgoingNomenclatureFields, append: appendOutgoingNomenclature, replace: replaceOutgoingNomenclature, remove: removeOutgoingNomenclature } = useFieldArray({
    control,
    name: "outgoing_nomenclature"
  });

  const { fields: equipmentSettingsFields, append: appendEquipmentSetting, replace: replaceEquipmentSettings, remove: removeEquipmentSetting } = useFieldArray({
    control,
    name: "equipment_settings"
  });
  

  const fillOperationForm = useCallback((operationData) => {
    if (operationData) {
      // установка значений в поля формы, если что-то ввели в поле или выбрана созданная операция
      setValue('name', operationData.name || selectedOperationData?.name || '');
      setValue('description', operationData.description || selectedOperationData?.description || '');

      replaceIncomingNomenclature(Array.isArray(operationData.incoming_nomenclature) ? operationData.incoming_nomenclature : []);
      replaceOutgoingNomenclature(Array.isArray(operationData.outgoing_nomenclature) ? operationData.outgoing_nomenclature : []);
      const equipmentSettings = Array.isArray(operationData.equipment_settings) ? operationData.equipment_settings : [];
      // Преобразуем execution_time в часы, минуты и секунды
      const transformedEquipmentSettings = equipmentSettings.map(item => {
        const totalSeconds = Number(item.execution_time || 0);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        return {
          ...item,
          hours,
          minutes,
          seconds,
        };
      });
      replaceEquipmentSettings(transformedEquipmentSettings);

    }
    /* if (equipmentSettingsFields.length === 0 && !defaultEquipmentAddedRef.current) {
      appendEquipmentSetting({
        equipment_group_id: '',
        hours: 0,
        minutes: 0,
        seconds: 0,
        is_parallel_process: false
      });
      defaultEquipmentAddedRef.current = true;
    } */
  }, [replaceEquipmentSettings, replaceIncomingNomenclature, replaceOutgoingNomenclature, selectedOperationData?.description, selectedOperationData?.name, setValue]);

  // кейс подготовки предыдущей операции, если выбрана номенклатура
  const preparePreviousOperation = useCallback(() => {
    setValue('name', '');
    setValue('description', '');

    let selectedNomenclature = nomenclatureOptions.find(({ nomenclature_id }) =>
      nomenclature_id === selectedNomenclatureId
    );
    replaceIncomingNomenclature([{
      nomenclature_id: '',
      quantity: 1
    }]);
    replaceOutgoingNomenclature(selectedNomenclature ? [selectedNomenclature] : []);
    replaceEquipmentSettings([
      {
        equipment_group_id: '',
        hours: 0,
        minutes: 0,
        seconds: 0,
        is_parallel_process: false
      }
    ]);
  }, [nomenclatureOptions, replaceEquipmentSettings, replaceIncomingNomenclature, replaceOutgoingNomenclature, selectedNomenclatureId, setValue])

  // если выбрана созданная операция, подставляем данные в форму
  useEffect(() => {
    if (selectedOperationData) {
      setOperationId(selectedOperationData.operation_id);
      fillOperationForm(selectedOperationData);
    } else {
      replaceOutgoingNomenclature(/* finalNomenclature || */[]);
    }
  }, [selectedOperationData, fillOperationForm, finalNomenclature, replaceOutgoingNomenclature]);

  useEffect(() => {
    if (selectedNomenclatureId) {
      setOperationId("");
      preparePreviousOperation();
    }
  }, [selectedOperationData, fillOperationForm, finalNomenclature, replaceOutgoingNomenclature, selectedNomenclatureId, preparePreviousOperation]);

  // Todo: вынести в api
  useEffect(() => {
    axios.get(`http://qcan-dev.smart-era.com:8001/cl/v1/nomenclature?enterprise_id=${enterpriseId}`)
      .then(response => setNomenclatureOptions(response.data))
      .catch(error => {
        notifyError(error?.response?.data?.message || error.message);
      });
  }, []);

  useEffect(() => {
    axios.get(`http://qcan-dev.smart-era.com:8001/cl/v1/equipment-group?division_id=${divisionId}`)
      .then(response => setEquipmentGroups(response.data))
      .catch(error => {
        notifyError(error?.response?.data?.message || error.message);
      });
  }, []);

  /* const [defaultIncomingAdded, setDefaultIncomingAdded] = useState(false);
  const [defaultEquipmentAdded, setDefaultEquipmentAdded] = useState(false);
  const defaultIncomingAddedRef = useRef(false);
  const defaultEquipmentAddedRef = useRef(false); */

  useEffect(() => {
    if (!serverData) return;

    // 1. Если операций нет
    if (serverData?.operations?.length === 0) {
      // Сбрасываем форму, показываем дефолтные поля
      reset({
        name: '',
        description: '',
        incoming_nomenclature: [{ nomenclature_id: '', quantity: 1 }],
        outgoing_nomenclature: finalNomenclatureId
          ? [{ nomenclature_id: finalNomenclatureId, quantity: 1 }]
          : [],
        equipment_settings: [{
          equipment_group_id: '',
          hours: 0,
          minutes: 0,
          seconds: 0,
          is_parallel_process: false,
        }],
      });
      setOperationId('');
      return; // Важно, чтобы дальше ничего не делали
    }

    // 2. Если есть выбранная операция
    if (selectedOperationData) {
      // Уже заполнили форму выше в useEffect, но на всякий случай перезаполним
      setOperationId(selectedOperationData.operation_id);
      fillOperationForm(selectedOperationData);
      return;
    }

    // 3. Если выбрана номенклатура (но операция не выбрана)
    if (selectedNomenclatureId) {
      setOperationId("");
      preparePreviousOperation();
      return;
    }

    // 4. Иначе (никакой операции не выбрано, но operations[] не пустой)
    //    — берём первую операцию и заполняем
    const firstOp = serverData.operations[0];
    setOperationId(firstOp.operation_id);
    fillOperationForm(firstOp);

  }, [
    serverData,
    selectedOperationData,
    selectedNomenclatureId,
    finalNomenclatureId,
    reset,
    fillOperationForm,
    preparePreviousOperation
  ]);
  

  const onSubmit = useCallback(async (formData) => {
    try {
      if (!formData.name || formData.name.length < 2 || formData.name.length > 200) {
        throw new Error('Поле name должно быть от 2 до 200 символов.');
      }
      const description = formData.description || '';

      if (description.length > 1000) {
        throw new Error('Поле description должно быть не более 1000 символов.');
      }

      const incomingNomenclature = formData.incoming_nomenclature.map(item => {
        if (!item.nomenclature_id || isNaN(Number(item.quantity))) {
          throw new Error('Каждый элемент incoming_nomenclature должен иметь nomenclature_id и числовое quantity.');
        }

        return {
          nomenclature_id: item.nomenclature_id,
          quantity: Number(item.quantity)
        };
      });

      const outgoingNomenclature = formData.outgoing_nomenclature.map(item => {
        if (!item.nomenclature_id || isNaN(Number(item.quantity))) {
          throw new Error('Каждый элемент outgoing_nomenclature должен иметь nomenclature_id и числовое quantity.');
        }

        return {
          nomenclature_id: item.nomenclature_id,
          quantity: Number(item.quantity)
        };
      });


      // Кейс с промежуточной операцией, у которой входящая номенклатура уже есть на Технической Карте
      // промежуточная операция должна соединяется с операцией у которой есть такая же исх. номенклатура как и вход. номенклатура промежуточной
      // {middlePrevOperation: [operation_id], middleNextOperation: [operation_id]}
      let middlePrevOperation;

      serverData.operations.forEach(currentOp => {console.log('123')
        if (selectedNomenclatureOperation?.operation_id) {
          const formDataIncomingNomenclatureId = formData?.incoming_nomenclature.map(({ nomenclature_id }) => nomenclature_id);
          currentOp.outgoing_nomenclature.forEach(currentNom => {
            if (formDataIncomingNomenclatureId.includes(currentNom.nomenclature_id)) {
              middlePrevOperation = [currentOp.operation_id];
              // middleNextOperation = [[selectedNomenclatureOperation.operation_id]]
            }
          })
        }
      });

      const previousOperations = formData.previous_operations || middlePrevOperation || selectedOperationData?.previous_operations || [];

      if (!Array.isArray(previousOperations) || !previousOperations.every(op => typeof op === 'string')) {
        throw new Error('previous_operations должно быть массивом строк.');
      }

      const nextOperations = formData.next_operations || selectedOperationData?.next_operations || (selectedNomenclatureOperation?.operation_id && [selectedNomenclatureOperation?.operation_id]) || [];
      if (!Array.isArray(nextOperations) || !nextOperations.every(op => typeof op === 'string')) {
        throw new Error('next_operations должно быть массивом строк.');
      }

      const equipmentSettings = formData.equipment_settings.map(item => {
        // Преобразуем часы, минуты и секунды в общее количество секунд
        const totalSeconds =
          (Number(item.hours || 0) * 3600) +
          (Number(item.minutes || 0) * 60) +
          Number(item.seconds || 0);

        const equipmentSetting = {
          equipment_group_id: item.equipment_group_id,
          execution_time: totalSeconds, // Используем общее количество секунд
          is_parallel_process: item.is_parallel_process || false,
        };

        if (item.is_parallel_process) {
          equipmentSetting.min_parallel_operations = Number(item.min_parallel_operations);
          equipmentSetting.max_parallel_operations = Number(item.max_parallel_operations);
        }

        return equipmentSetting;
      });

      // Если операция существует, то обновляем операцию (PUT). Если новая - создаем ее(POST)
      const isExistOperation = operationId && !selectedNomenclatureOperation && !middlePrevOperation;

      const formattedData = {
        product_sheet_id: productSheetId,
        name: formData.name,
        description: formData.description || '',
        incoming_nomenclature: incomingNomenclature,
        outgoing_nomenclature: outgoingNomenclature,
        previous_operations: previousOperations,
        next_operations: nextOperations,
        equipment_settings: equipmentSettings,
      };

      const url = isExistOperation ?
        `http://qcan-dev.smart-era.com:8001/cl/v1/product-sheet/operation/${operationId}` :
        `http://qcan-dev.smart-era.com:8001/cl/v1/product-sheet/operation`;

      const method = operationId && !selectedNomenclatureOperation ? 'put' : 'post';

      const response = await axios({ method, url, data: formattedData, headers: { 'Content-Type': 'application/json' } });

      if (!operationId && response.data.operationId) {
        setOperationId(response.data.operationId);
      }

      fetchTKModel(productSheetId, updateServerData);
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  }, [operationId, productSheetId, selectedNomenclatureOperation, selectedOperationData?.next_operations, selectedOperationData?.previous_operations, serverData.operations, updateServerData]);

  const deleteOperation = useCallback(async () => {
    try {
      await axios.delete(`http://qcan-dev.smart-era.com:8001/cl/v1/product-sheet/operation/${operationId}`);
      console.log('Операция удалена успешно');
      fetchTKModel(productSheetId, updateServerData);
      //resetFormToInitialState();
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  }, [operationId, productSheetId, updateServerData, resetFormToInitialState]);

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Card className="card-primary mb-4">
        <Card.Header className='card-title-neutral'>
          <Card.Title>Изменение операции</Card.Title>
        </Card.Header>
        <Card.Body>
          {/* Название и Описание */}
          <Form.Group as={Row} controlId="operationName">
            <Form.Label column sm={3} className="form-label">Название</Form.Label>
            <Col sm={9}>
              <Controller
                control={control}
                name="name"
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    type="text"
                    placeholder="Введите название операции"
                    className={`compact-input ${errors.name ? 'is-invalid' : ''}`}
                  />
                )}
              />
              {errors.name && <div className="invalid-feedback">{errors.name.message}</div>}
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="operationDescription">
            <Form.Label column sm={3} className="form-label">Описание</Form.Label>
            <Col sm={9}>
              <Controller
                control={control}
                name="description"
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    as="textarea"
                    rows={2}
                    placeholder="Введите описание операции"
                    className={`compact-input ${errors.description ? 'is-invalid' : ''}`}
                  />
                )}
              />
              {errors.description && <div className="invalid-feedback">{errors.description.message}</div>}
            </Col>
          </Form.Group>

          {/* Входящая номенклатура */}
          <Card className="card-secondary mb-4" style={{ marginTop: '1.5rem' }}>
            <Card.Header>
              <Card.Title>Входящая номенклатура</Card.Title>
            </Card.Header>
            <Card.Body>
              {incomingNomenclatureFields.map((field, index) => (
                <div key={field.id} className="mb-3">
                  <Row>
                    <Col sm={12}>
                      <Form.Label className="form-label">Номенклатура {index + 1}</Form.Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={5}>
                      <Controller
                        control={control}
                        name={`incoming_nomenclature.${index}.nomenclature_id`}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            as="select"
                            className={`compact-input ${errors.incoming_nomenclature?.[index]?.nomenclature_id ? 'is-invalid' : ''}`}
                          >
                            <option value="">Выберите номенклатуру</option>
                            {nomenclatureOptions.map((option) => (
                              <option key={option.nomenclature_id} value={option.nomenclature_id}>
                                {option.name}
                              </option>
                            ))}
                          </Form.Control>
                        )}
                      />
                      {errors.incoming_nomenclature?.[index]?.nomenclature_id && (
                        <div className="invalid-feedback">
                          {errors.incoming_nomenclature[index].nomenclature_id.message}
                        </div>
                      )}
                    </Col>
                    <Col sm={3}>
                      <Controller
                        control={control}
                        name={`incoming_nomenclature.${index}.quantity`}
                        render={({ field }) => (
                          <Form.Control
                            min="1"
                            {...field}
                            type="number"
                            placeholder="Кол-во"
                            className={`compact-input ${errors.incoming_nomenclature?.[index]?.quantity ? 'is-invalid' : ''}`}
                          />
                        )}
                      />
                      {errors.incoming_nomenclature?.[index]?.quantity && (
                        <div className="invalid-feedback">
                          {errors.incoming_nomenclature[index].quantity.message}
                        </div>
                      )}
                    </Col>
                    {/* Показываем кнопку удаления, только если длина массива больше 1 */}
                    {incomingNomenclatureFields.length > 1 && (
                      <Col sm={1}>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => removeIncomingNomenclature(index)}
                        >
                          <i className="fa fa-minus" /> -
                        </Button>
                      </Col>
                    )}
                  </Row>
                </div>
              ))}
              <Button
                variant="success"
                size="sm"
                onClick={() => appendIncomingNomenclature({ nomenclature_id: '', quantity: '1' })}
              >
                <i className="fa fa-plus" /> Добавить номенклатуру
              </Button>
            </Card.Body>
          </Card>

          {/* Исходящая номенклатура */}
          <Card className="card-secondary mb-4">
            <Card.Header>
              <Card.Title>Исходящая номенклатура</Card.Title>
            </Card.Header>
            <Card.Body>
              {outgoingNomenclatureFields.map((field, index) => {
                const isFinalNomenclature = field.nomenclature_id === finalNomenclatureId;

                return (
                  <div key={field.id} className="mb-3">
                    <Row>
                      <Col sm={12}>
                        <Form.Label className="form-label">Номенклатура {index + 1}</Form.Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={5}>
                        <Controller
                          control={control}
                          name={`outgoing_nomenclature.${index}.nomenclature_id`}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              as="select"
                              disabled={isFinalNomenclature}
                              className={`compact-input ${
                                errors.outgoing_nomenclature?.[index]?.nomenclature_id 
                                  ? 'is-invalid' 
                                  : ''
                              }`}
                            >
                              <option value="">Выберите номенклатуру</option>
                              {nomenclatureOptions.map((option) => (
                                <option 
                                  key={option.nomenclature_id} 
                                  value={option.nomenclature_id}
                                >
                                  {option.name}
                                </option>
                              ))}
                            </Form.Control>
                          )}
                        />
                        {errors.outgoing_nomenclature?.[index]?.nomenclature_id && (
                          <div className="invalid-feedback">
                            {errors.outgoing_nomenclature[index].nomenclature_id.message}
                          </div>
                        )}
                      </Col>
                      <Col sm={3}>
                        <Controller
                          control={control}
                          name={`outgoing_nomenclature.${index}.quantity`}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="number"
                              min="1"
                              placeholder="Кол-во"
                              className={`compact-input ${
                                errors.outgoing_nomenclature?.[index]?.quantity 
                                  ? 'is-invalid' 
                                  : ''
                              }`}
                            />
                          )}
                        />
                        {errors.outgoing_nomenclature?.[index]?.quantity && (
                          <div className="invalid-feedback">
                            {errors.outgoing_nomenclature[index].quantity.message}
                          </div>
                        )}
                      </Col>
                      {!isFinalNomenclature && outgoingNomenclatureFields.length > 1 && (
                        <Col sm={1}>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => removeOutgoingNomenclature(index)}
                          >
                            <i className="fa fa-minus" /> -
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </div>
                );
              })}
              <Button
                variant="success"
                size="sm"
                onClick={() => appendOutgoingNomenclature({ nomenclature_id: '', quantity: '1' })}
              >
                <i className="fa fa-plus" /> Добавить номенклатуру
              </Button>
            </Card.Body>
          </Card>

          {/* Параметры оборудования */}
          <Card className="card-secondary mb-4">
            <Card.Header>
              <Card.Title>Параметры оборудования</Card.Title>
            </Card.Header>
            <Card.Body>
              {equipmentSettingsFields.map((field, index) => (
                <div key={field.id} className="mb-3">
                  <Row>
                    <Col sm={12}>
                      <Form.Label className="form-label">Группа оборудования {index + 1}</Form.Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={5}>
                      <Controller
                        control={control}
                        name={`equipment_settings.${index}.equipment_group_id`}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            as="select"
                            className={`compact-input ${errors.equipment_settings?.[index]?.equipment_group_id ? 'is-invalid' : ''}`}
                          >
                            <option value="">Выберите группу оборудования</option>
                            {equipmentGroups.map((group) => (
                              <option key={group.equipment_group_id} value={group.equipment_group_id}>
                                {group.name}
                              </option>
                            ))}
                          </Form.Control>
                        )}
                      />
                      {errors.equipment_settings?.[index]?.equipment_group_id && (
                        <div className="invalid-feedback">
                          {errors.equipment_settings[index].equipment_group_id.message}
                        </div>
                      )}
                    </Col>
                    
                    {equipmentSettingsFields.length > 1 && (
                      <Col sm={1} className="d-flex align-items-end">
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => removeEquipmentSetting(index)}
                        >
                          <i className="fa fa-minus" /> -
                        </Button>
                      </Col>
                    )}
                  </Row>
                  
                  <Row className="mt-2">
                    <Col sm={12} style={{ display: "flex", flexDirection: "column" }}>
                      <Form.Group as={Row} controlId={`equipment_settings.${index}.execution_time`} style={{ display: "flex", flexDirection: "column" }}>
                        <Form.Label column sm={2} className="form-label">Время выполнения</Form.Label>
                        <Col sm={10}>
                          <Row>
                            <Col sm={4}>
                              <Controller
                                control={control}
                                name={`equipment_settings.${index}.hours`}
                                render={({ field }) => (
                                  <>
                                    <Form.Label className="form-label">Часы</Form.Label>
                                    <Form.Control
                                      {...field}
                                      type="number"
                                      placeholder="0"
                                      min="0"
                                      className={`compact-input ${errors.equipment_settings?.[index]?.hours ? 'is-invalid' : ''}`}
                                    />
                                    {errors.equipment_settings?.[index]?.hours && (
                                      <div className="invalid-feedback">
                                        {errors.equipment_settings[index].hours.message}
                                      </div>
                                    )}
                                  </>
                                )}
                              />
                            </Col>
                            <Col sm={4}>
                              <Controller
                                control={control}
                                name={`equipment_settings.${index}.minutes`}
                                render={({ field }) => (
                                  <>
                                    <Form.Label className="form-label">Минуты</Form.Label>
                                    <Form.Control
                                      {...field}
                                      min="0"
                                      max="59"
                                      type="number"
                                      placeholder="0"
                                      className={`compact-input ${errors.equipment_settings?.[index]?.minutes ? 'is-invalid' : ''}`}
                                    />
                                    {errors.equipment_settings?.[index]?.minutes && (
                                      <div className="invalid-feedback">
                                        {errors.equipment_settings[index].minutes.message}
                                      </div>
                                    )}
                                  </>
                                )}
                              />
                            </Col>
                            <Col sm={4}>
                              <Controller
                                control={control}
                                name={`equipment_settings.${index}.seconds`}
                                render={({ field }) => (
                                  <>
                                    <Form.Label className="form-label">Секунды</Form.Label>
                                    <Form.Control
                                      {...field}
                                      type="number"
                                      min="0"
                                      max="59"
                                      placeholder="0"
                                      className={`compact-input ${errors.equipment_settings?.[index]?.seconds ? 'is-invalid' : ''}`}
                                    />
                                    {errors.equipment_settings?.[index]?.seconds && (
                                      <div className="invalid-feedback">
                                        {errors.equipment_settings[index].seconds.message}
                                      </div>
                                    )}
                                  </>
                                )}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                              
                  {/* Параллельное выполнение */}
                  <Row className="mt-2">
                    <Col sm={12}>
                      <Controller
                        control={control}
                        name={`equipment_settings.${index}.is_parallel_process`}
                        render={({ field }) => (
                          <Form.Check
                            type="checkbox"
                            label="Параллельное выполнение"
                            checked={field.value || false}
                            onChange={(e) => field.onChange(e.target.checked)}
                            className="form-check-inline"
                          />
                        )}
                      />
                    </Col>
                  </Row>
                      
                  {watch(`equipment_settings.${index}.is_parallel_process`) && (
                    <Row className="mt-2">
                      <Col sm={3}>
                        <Controller
                          control={control}
                          name={`equipment_settings.${index}.min_parallel_operations`}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="number"
                              min="1"
                              placeholder="Мин. операций"
                              className={`compact-input ${errors.equipment_settings?.[index]?.min_parallel_operations ? 'is-invalid' : ''}`}
                            />
                          )}
                        />
                        {errors.equipment_settings?.[index]?.min_parallel_operations && (
                          <div className="invalid-feedback">
                            {errors.equipment_settings[index].min_parallel_operations.message}
                          </div>
                        )}
                      </Col>
                      <Col sm={3}>
                        <Controller
                          control={control}
                          name={`equipment_settings.${index}.max_parallel_operations`}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="number"
                              min="1"
                              placeholder="Макс. операций"
                              className={`compact-input ${errors.equipment_settings?.[index]?.max_parallel_operations ? 'is-invalid' : ''}`}
                            />
                          )}
                        />
                        {errors.equipment_settings?.[index]?.max_parallel_operations && (
                          <div className="invalid-feedback">
                            {errors.equipment_settings[index].max_parallel_operations.message}
                          </div>
                        )}
                      </Col>
                    </Row>
                  )}
                </div>
              ))}
              <Button
                variant="success"
                size="sm"
                onClick={() => appendEquipmentSetting({ equipment_group_id: '', execution_time: '', is_parallel_process: false })}
              >
                <i className="fa fa-plus" /> Добавить параметр
              </Button>
            </Card.Body>
          </Card>
        </Card.Body>
        <Card.Footer>
          <Button type="submit" variant="primary" size="sm" className="mr-2">Сохранить</Button>
          <Button type="button" variant="danger" size="sm" onClick={deleteOperation}>Удалить</Button>
        </Card.Footer>
      </Card>
    </Form>
  );
};
/* 1 */
export default memo(OperationForm);